import { Service_SSO } from '../../service';
const state = {
  isAuthenticateSaml:false,
};

const mutations = {

  setIsAuthenticateSaml(state, data) {
    state.isAuthenticateSaml = data;
  },
};

const actions = {

  async setAuthenticateSaml({ commit }) {
    const { data } = await Service_SSO.getIsAuthenticate();
    console.log('setAuthenticateSaml : data',data)
    commit('setIsAuthenticateSaml', data.is_authenticated);

  },
};

const getters = {
  isAuthenticateSaml: state => state.isAuthenticateSaml,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};




// WEBPACK FOOTER //
// ./src/store/modules/custom.js